import { brandStats, reviews } from "@/mocks/gossipData";

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-foreground-950 text-background-100 py-12 md:py-16 relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 -top-24 w-80 h-80 rounded-full bg-primary-600/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 w-72 h-72 rounded-full bg-accent-500/10 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* 品牌介绍 */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-300 text-xs font-semibold tracking-widest">
              <i className="ri-community-line"></i> ABOUT MELON DAILY
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-background-50">关于绯闻瓜田</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
              绯闻瓜田是一处专注娱乐圈明星绯闻与情感动态的八卦资讯站。我们相信，每一次恋情曝光、官宣或体面分手，背后都有一段值得被讲清楚的故事。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-background-200">
              我们不只做信息的搬运工，更坚持<b className="text-accent-300">核实来源</b>、<b className="text-accent-300">梳理时间线</b>与<b className="text-accent-300">保留多元视角</b>。吃瓜可以热热闹闹，但内容必须踏踏实实——这是绯闻瓜田始终如一的内容原则。
            </p>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {brandStats.map((s) => (
                <div key={s.label} className="bg-background-50/5 border border-background-50/10 rounded-md p-3 text-center">
                  <p className="font-heading text-lg md:text-xl font-extrabold text-accent-300">{s.value}</p>
                  <p className="mt-1 text-[11px] text-background-300 whitespace-nowrap">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-3 text-xs text-background-300">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-shield-check-line text-accent-300"></i> 来源可查
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-scales-3-line text-accent-300"></i> 客观克制
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-timer-flash-line text-accent-300"></i> 实时跟进
              </span>
            </div>
          </div>

          {/* 用户口碑 */}
          <div>
            <h3 className="font-heading text-xl font-bold text-background-50 mb-5 flex items-center gap-2">
              <i className="ri-heart-3-line text-primary-400"></i> 瓜田小伙伴的口碑
            </h3>
            <div className="flex flex-col gap-4">
              {reviews.map((r) => (
                <figure key={r.name} className="bg-background-50/5 border border-background-50/10 rounded-lg p-4 md:p-5">
                  <div className="flex items-center justify-between">
                    <figcaption className="flex items-center gap-3">
                      <img
                        src={r.avatar}
                        alt={`${r.name}头像`}
                        className="w-10 h-10 rounded-full object-cover"
                        loading="lazy"
                      />
                      <div>
                        <p className="text-sm font-semibold text-background-50">{r.name}</p>
                        <p className="text-[11px] text-background-400">{r.role}</p>
                      </div>
                    </figcaption>
                    <span className="flex items-center gap-0.5 text-accent-300 text-sm">
                      {Array.from({ length: r.star }).map((_, i) => (
                        <i key={i} className="ri-star-fill"></i>
                      ))}
                    </span>
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-background-200">“{r.quote}”</blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}